import styled from 'styled-components';
import { BouColor } from '../../../global/bou-colors';
import CheckBoxSvg from './checkbox.svg';

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
  size?: string;
  disabled?: boolean;
}

export const BouCheckBox = (props: Props) => {
  const size = props.size || '1.0em';
  return (
    <Root
      size={size}
      disabled={props.disabled || false}
      onClick={() => {
        props.onChange(!props.checked);
      }}
    >
      <InvisibleCheckBox
        checked={props.checked}
        onChange={() => {
          props.onChange(!props.checked);
        }}
      />
      <CheckBox size={size} checked={props.checked} disabled={props.disabled || false} />
    </Root>
  );
};

const Root = styled.div<{ size: string; disabled: boolean }>`
  width: ${props => props.size};
  height: ${props => props.size};
  position: relative;
  display: flex;
  align-items: center;
  cursor: ${props => (props.disabled ? 'default' : 'pointer')};
  &:hover {
    color: ${props => (props.disabled ? BouColor.DARK_GRAY_NO_ALPHA : BouColor.TOOL_TEXT_LIGHT_GRAY)};
  }
`;

const CheckBox = styled(CheckBoxSvg)<{ size: string; checked: boolean; disabled: boolean }>`
  width: ${props => props.size};
  height: ${props => props.size};
  flex-shrink: 0;
  position: absolute;
  top: 0;
  left: 0;
  .checkbox_svg__cross,
  .cross {
    fill: ${props => (props.checked ? 'currentColor' : 'transparent')};
  }
  .checkbox_svg__border,
  .border {
    stroke: currentColor;
  }
`;

// For accessibility stuff
const InvisibleCheckBox = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  flex-shrink: 0;
  position: absolute;
  margin: 0;
`;
